'use strict'

var caseSensitiveTransform = require('./case-sensitive-transform')

module.exports = caseInsensitiveTransform

function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase())
}



//////////////////
// WEBPACK FOOTER
// ./~/hast-to-hyperscript/~/property-information/lib/util/case-insensitive-transform.js
// module id = 257
// module chunks = 131683993344931